export const TILE_SIZE = 16

export const COLOR_HEX_PURPLE = '#5F168E'
export const COLOR_HEX_LIME = '#C4D600'
export const COLOR_HEX_LIME_LIGHT = '#F0F5BF'
